import graphql__5987579e8244f699cf43 from "./__generated__/ConfigureAccountMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";
import { serializeUserFormValues } from "../components/Utils/serializeUserFormValues";

// Static fields that are always present in the form, allowing us to separate
// those fields from the one created in the admin panel when we serialize our
// form for the mutation
const staticFields = ["name", "password", "passwordConfirmation"];

const mutation = graphql__5987579e8244f699cf43;

function configureAccount(form, onCompleted) {
  const variables = serializeUserFormValues(form, staticFields);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { configureAccount };
